import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'

export const TopicAreaNote = () => {
  return <Translation text={getFormedEltTranslation('topic-area-note')} />
}
